// extracted by mini-css-extract-plugin
module.exports = {"addItem":"styles_addItem__2Y6_2","label":"styles_label__AqeD4","scrollbars":"styles_scrollbars__HoNDW","slideInSearchBar":"styles_slideInSearchBar__kFp1j"};